import { render } from "./AhMessage.vue?vue&type=template&id=6dd85623&scoped=true"
import script from "./AhMessage.vue?vue&type=script&lang=js"
export * from "./AhMessage.vue?vue&type=script&lang=js"

import "./AhMessage.vue?vue&type=style&index=0&id=6dd85623&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd85623"]])

export default __exports__